module.exports = __webpack_public_path__ + "static/media/53.7cfaf1f8.jpg";